// src/pages/ResetPassword.jsx
import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import { Eye, EyeOff } from 'lucide-react';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get('email');
  const token = searchParams.get('token');
  
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    if (!email || !token) {
      setMessage({ type: 'error', text: 'Invalid reset link.' });
    }
  }, [email, token]);

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage({});

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, newPassword: password })
      });

      const data = await res.json();

      if (res.ok) {
        setMessage({ type: 'success', text: data.message });
        setTimeout(() => navigate('/'), 2000);
      } else {
        setMessage({ type: 'error', text: data || 'Error resetting password' });
      }
    } catch {
      setMessage({ type: 'error', text: 'Network error' });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#181818]">
      <div className="bg-[#222] p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-semibold text-white mb-4">Reset Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="New Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-2 bg-[#111] border border-[#2b2b2b] rounded-lg text-white pr-10"
              required
            />
            {password && (
              <button
                type="button"
                className="absolute right-3 top-[50%] transform -translate-y-1/2 text-gray-400"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            )}
          </div>
          <button
            type="submit"
            className="w-full bg-lime-400 hover:bg-lime-300 text-[#181f10] font-semibold py-2 px-4 rounded-lg"
          >
            Reset Password
          </button>
        </form>
        {message.text && (
          <p className={`mt-3 text-sm ${message.type === 'success' ? 'text-yellow-400' : 'text-red-400'}`}>
            {message.text}
          </p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
